import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';

@Component({
	imports: [CommonModule],
	selector: 'app-back-btn',
	standalone: true,
	styleUrls: ['./back-btn.component.scss'],
	templateUrl: './back-btn.component.html'
})
export class BackBtnComponent {
	constructor(private location: Location) {}

    goBack(): void{
        this.location.back();
    }
}
